import {
  ContentServiceClient,
} from "@data/content-service-client";
import { ContentServiceGetStorySearchParams } from "@data/content-service-client/types";

import { wrapResponse } from "./wrapResponse";

async function getStoriesHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as ContentServiceGetStorySearchParams;

  const contentServiceClient = ContentServiceClient.init({
    host: process.env.CONTENT_SERVICE_URL,
    username: process.env.CONTENT_SERVICE_USERNAME,
    password: process.env.CONTENT_SERVICE_PASSWORD,
  });

  const contentServiceResponse =
    await contentServiceClient.getV1StoriesSearchBy(params);

  return res.status(200).json({
    data: contentServiceResponse?.collection?.items,
  });
}

export default getStoriesHandler;
